import { ThemeColors } from '~/themes/colors'

interface DetailViewColors {
  DataContainer: {
    Background: ThemeColors
    FontColor: ThemeColors
    Transcript: {
      Border: ThemeColors
      FontColor: ThemeColors
    }
  }
}

export const detailViewColors: DetailViewColors = {
  DataContainer: {
    Background: {
      default: 'gray.100',
    },
    FontColor: {
      default: 'gray.800',
    },
    Transcript: {
      Border: {
        default: 'gray.300',
      },
      FontColor: {
        default: 'gray.800',
      },
    },
  },
}
